<template>
    <div
        class="drop-down"
        :class="{ 'drop-down--open' : open }"
        @mousedown.stop>
        <a
            href
            class="drop-down__selection"
            @click.prevent.stop="toggle">
            <div class="drop-down__selection-label">
                {{ noSelection ? 'Velg din biltype' : activeLabel }}
            </div>
            <div class="drop-down__selection-icon-wrap">
                <icon name="select-arrow" class="drop-down__selection-icon" />
            </div>
        </a>
        <transition
            name="fade-sweep"
            appear>
            <ul
                v-if="open"
                class="drop-down__list">
                <li
                    v-for="(item, i) in list"
                    :key="i">
                    <a
                        href
                        class="drop-down__list-link"
                        @click.prevent.stop="itemClick(i)">
                        {{ item.label }}
                    </a>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
import { kebabCase } from 'lodash';
import Icon from '@/components/Icon';
export default {
    name: 'DropDown',
    components: {
        Icon
    },
    props: {
        list: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            open: false
        };
    },
    computed: {
        activeLabel () {
            return (this.$store.getters.activeSelection && this.$store.getters.activeSelection.label) || '';
        },
        noSelection () {
            return this.$route.fullPath === '/' || this.$route.fullPath === '';
        }
    },
    watch: {
        open (bool) {
            if (bool) {
                document.addEventListener('mousedown', this.mouseDownOutside);
            } else {
                document.removeEventListener('mousedown', this.mouseDownOutside);
            }
        }
    },
    beforeDestroy () {
        document.removeEventListener('mousedown', this.mouseDownOutside);
    },
    methods: {
        toggle () {
            this.open = !this.open;
        },
        itemClick (index) {
            const type = this.list[index].type;
            const path = `/${kebabCase(type)}/`;
            this.$emit('select', path);
            this.open = false;
        },
        mouseDownOutside () {
            this.open = false;
        }
    }
};
</script>

<style lang="scss">
.drop-down{
    $block: &;
    position: relative;
    width: 100%;
    max-width: 264px;
    @include breakpoint(medium down){
        margin: 0 auto;
    }
    &__selection{
        position: relative;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        height: spacing(6);
        text-decoration: none;
        background-color: color(green);
        z-index: 100;
        &-label{
            padding: 0 spacing(2);
            white-space: nowrap;
            color: color(white);
        }
        &-icon-wrap{
            display: flex;
            width: spacing(6);
            background-color: color(dark-grey);
            justify-content: center;
            align-items: center;
            position: relative;
            margin-left: auto;
            height: inherit;
        }
        &-icon{
            transition: transform .25s ease;
            #{$block}--open &{
                transform: rotate(-180deg);
            }
        }
    }
    &__list{
        position: absolute;
        z-index: 99;
        display: block;
        margin: 0;
        list-style: none;
        padding: spacing(3) 0;
        top: 100%;
        left: 0;
        width: 100%;
        height: auto;
        background-color: color(body-bg);
        box-shadow: 0 6px 8px color(black, .16);
        li{
            position: relative;
            display: block;
            padding: 0;
            &:after,
            &:before{
                content: '';
                position: absolute;
                left: spacing(3);
                right: spacing(3);
                height: 0;
            }
            &:before{
                bottom: 1px;
                border-bottom: solid 1px color(line-grey);
            }
            &:after{
                bottom: 0;
                border-bottom: solid 1px color(white);
            }
            &:last-child{
                &:after,
                &:before{
                    display: none;
                }
            }
        }
        &-link{
            display: block;
            padding: spacing(2) spacing(3);
            text-decoration: none;
            color: color(primary-text);
            transition: opacity .25s ease;
            &:hover{
                opacity: .75;
            }
        }
    }
}
</style>
